import React, { useEffect, useState } from 'react'
import * as web3Service from '../../../blockchain/web3.service'
import { DateTime } from 'luxon'
import { Spin } from 'antd'
import Countdown from 'react-countdown'
import EventEmitter from '../../../Utils/EventEmitter'
export default function NextBonusTimeTimer(props) {

  const { accountAddress } = props
  const [nextBonusTimestamp, setNextBonusTimestamp] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [logs, setLogs] = useState(null)

  useEffect(() => {
    const onNewLogs = (eventData) => {
      setLogs(eventData)
    }
    const listener = EventEmitter.addListener('HireDragonEvent', onNewLogs)
    return () => {
      listener.remove()
    }
  }, [])


  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    calculateNextBonusTimestamp(accountAddress)
  }, [accountAddress, logs])


  const renderer = ({ days, hours, minutes, seconds }) => {

    let totalHours = 0
    let totalMinutes = minutes
    let totalSeconds = seconds

    if (parseInt(days) >= 1) {
      totalHours = parseInt(hours) + parseInt(days) * 24
    } else {
      totalHours = parseInt(hours)
    }

    if (parseInt(totalHours) < 10) { totalHours = '0' + totalHours; }
    if (parseInt(totalMinutes) < 10) { totalMinutes = '0' + totalMinutes; }
    if (parseInt(totalSeconds) < 10) { totalSeconds = '0' + totalSeconds; }

    return <span>{totalHours}h:{totalMinutes}m:{totalSeconds}s</span>
  };

  const calculateNextBonusTimestamp = async (accountAddress) => {
    try {
      setIsLoading(true)
      if (accountAddress) {
        const userInfoResponse = await web3Service.getDragonDetailsByUserAddress(accountAddress)
        if (userInfoResponse && userInfoResponse.lastHatchTimestamp) {
          const lastHatchTimestamp = parseInt(userInfoResponse.lastHatchTimestamp)
          if (lastHatchTimestamp > 0) {

            const compoundSteps = await web3Service.getCompoundSteps()
            const compoundCumulative = lastHatchTimestamp + parseInt(compoundSteps)
            const timestampMills = DateTime.fromSeconds(compoundCumulative).toMillis()
            setNextBonusTimestamp(timestampMills)
          } else {
            setNextBonusTimestamp(null)
          }
        } else {
          setNextBonusTimestamp(null)
        }
      } else {
        setNextBonusTimestamp(null)
      }
      setIsLoading(false)
    } catch (error) {
      console.log("ERROR next bonus timestamp component ", error)
      setNextBonusTimestamp(null)
      setIsLoading(false)
    }
  }

  return (
    <div>
      {
        isLoading ? (
          <div className='loading-container'>
            <Spin style={{ color: 'red' }} size="small" />
          </div>
        ) : (
          <span>
            {
              nextBonusTimestamp ? (
                <Countdown
                  date={nextBonusTimestamp}
                  renderer={renderer}
                  daysInHours={true}
                />
              ) : (<span>00h:00m:00s</span>)
            }

          </span>
        )
      }

    </div>
  )
}
